<template>
  <div>
    <div style="text-align: center;margin-top: 10%;font-size: 20px;">{{ $t("dashboard.underMaintenance") }}</div>
    <div class="va-row"
         style="display: none;">
      <div class="flex md12 xs12"
           style="padding-top: 16px;">
        <vuestic-widget>
          <div class="va-row">
            <div class="flex md3">
              <div class="select-title">{{ $t("t.app") }}</div>
              <el-select v-model="value_app"
                         :placeholder="$t('common.selectPlaceholder')">
                <el-option :label="$t('basic.select.all')"
                           value=""
                           selected />
                <el-option v-for="item in appList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="flex md3">
              <div class="select-title">{{ $t("t.currency") }}</div>
              <el-select v-model="value_cur"
                         :placeholder="$t('common.selectPlaceholder')">
                <el-option :label="$t('basic.select.all')"
                           value=""
                           selected />
                <el-option v-for="(val,index) in currencyList"
                           :key="index"
                           :label="val"
                           :value="val">
                </el-option>
              </el-select>
            </div>
            <div class="flex md3">
              <div class="select-title">{{ $t("t.method") }}</div>
              <el-select v-model="value_method"
                         :placeholder="$t('common.selectPlaceholder')">
                <el-option :label="$t('basic.select.all')"
                           value=""
                           selected />
                <el-option v-for="(item,index) in methodList"
                           :key="index"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="flex md3">
              <div class="block">
                <span class="select-title">{{ $t("basic.select.date") }}</span>
                <el-date-picker id="dateRange"
                                @focus="setCalendarPanel"
                                v-model="dateVals"
                                @change="dateChangebirthday1"
                                type="daterange"
                                :picker-options="pickerDate"
                                range-separator="-"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                start-placeholder="start"
                                end-placeholder="end">
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="flex">
            <button class="btn btn-primary btn-micro"
                    @click="setSearch">
              <div class="btn-with-icon-content">
                <i class="fa fa-refresh"></i>
                {{'basic.button.apply' | translate}}
              </div>
            </button>
          </div>
        </vuestic-widget>
      </div>
      <div class="flex md6 xl3 xs12 wbot">
        <vuestic-widget class="info-widget">
          <div class="info-widget-inner">
            <div class="w-title">
              <span>{{ $t("tables.reporting.revenue") }}</span>
            </div>
            <div class="w-content"
                 v-for="(item, index) in revenue"
                 :key="index">
              <span>{{item}}</span>
            </div>
          </div>
        </vuestic-widget>
      </div>
      <div class="flex md6 xl3 xs12 wbot">
        <vuestic-widget class="info-widget">
          <div class="info-widget-inner">
            <div class="w-title">
              <span>{{ $t("dashboard.tradingVolume") }}</span>
            </div>
            <div class="w-content"
                 v-for="(item, index) in volume"
                 :key="index">
              <span>{{item}}</span>
            </div>
          </div>
        </vuestic-widget>
      </div>
      <div class="flex md6 xl3 xs12 wbot">
        <vuestic-widget class="info-widget ">
          <div class="info-widget-inner">
            <div class="w-title">
              <span>{{ $t("dashboard.avgTicket") }}</span>
            </div>
            <div class="w-content"
                 v-for="(item, index) in avg"
                 :key="index">
              <span>{{item}}</span>
            </div>
          </div>
        </vuestic-widget>
      </div>

      <div class="flex xs12 md12 w-table"
           v-if="isMobile === 'pc'">
        <div class="chart_con">
          <div id="qChart"
               ref="qChart"
               class="flex md12 xl3 xs12"></div>
          <div id="sChart"
               ref="sChart"
               class="flex md12 xl3 xs12"></div>
        </div>
      </div>
      <div v-else
           class="flex xs12 md12 w-table">
        <div class="flex xs12 md12 w-table">
          <div id="qChart"
               ref="qChart"
               class="flex md12 xl3 xs12"></div>
        </div>
        <div class="flex xs12 md12 w-table">
          <div id="sChart"
               ref="sChart"
               class="flex md12 xl3 xs12"></div>
        </div>
      </div>

      <div class="flex xs12 md12 w-table">
        <vuestic-widget id="datagridSettlement"
                        :headerText="$t('tables.basic')">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <td>{{'tables.headings.methods' | translate}}</td>
                  <td>{{'tables.headings.success' | translate}}</td>
                  <td>{{'tables.headings.refused' | translate}}</td>
                  <td>{{'tables.headings.refunded' | translate}}</td>
                  <td>{{'tables.headings.chargeback' | translate}}</td>
                  <td align="right">{{'tables.headings.trans' | translate}}</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in listData"
                    :key="index">
                  <td>{{index}}</td>
                  <td v-if="item.SUCCESS != undefined">{{item.SUCCESS}}</td>
                  <td v-else>0</td>
                  <td v-if="item.REFUSED != undefined">{{item.REFUSED}}</td>
                  <td v-else>0</td>
                  <td v-if="item.REFUNDED != undefined">{{item.REFUNDED}}</td>
                  <td v-else>0</td>
                  <td v-if="item.CHARGEBACK != undefined">{{item.CHARGEBACK}}</td>
                  <td v-else>0</td>
                  <td align="right">{{item.count}}</td>
                  <td></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>{{ $t("t.total") }}</td>
                  <td>{{ totalAmount.success }}</td>
                  <td>{{ totalAmount.refused }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>

</template>

<script>
import CountriesList from "data/CountriesList";
import wChart from "../statistics/charts/Charts";
import BigNumber from "bignumber.js/bignumber.mjs";
import { request } from "@/utils/utils";
export default {
  name: "dashboard",
  data() {
    return {
      revenue: ["N/A"],
      volume: ["N/A"],
      avg: ["N/A"],
      check: [
        {
          coun: "country",
        },
      ],
      pickerDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        onPick({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            this.disabledDate = (time) => {
              let curDate = new Date().getTime();
              let three = 90 * 24 * 3600 * 1000;
              let threeMonths = curDate - three;
              let chazhi = minDate.getTime() - threeMonths;
              return (
                time.getTime() >
                  (chazhi > 0 ? Date.now() : minDate.getTime() + three) ||
                time.getTime() < minDate
              );
            };
          }
          if (minDate && maxDate) {
            this.disabledDate = (time) => {
              return time.getTime() > Date.now();
            };
          }
        },
      },
      timeDefaultShow: "",
      // clearable:true,
      borlist: [],
      dashlist: [],
      amount_sum: "",
      dashlistB: {
        amount_sum: "",
        count_sum: "",
        average: "",
      },
      dashlistU: {
        amount_sum: "",
        count_sum: "",
        average: "",
      },
      appList: "",
      currencyList: "",
      methodList: "",
      listData: [],
      value: [],
      value_app: "",
      value_cur: "",
      value_method: "",
      nowTime: "",
      isMale: true,
      countriesList: CountriesList,
      chosenCountry: "",
      clearableText: "",
      successfulEmail: "andrei@dreamsupport.io",
      wrongEmail: "andrei@dreamsupport",
      // dateVals: [new Date("2019-08-01"),new Date("2019-08-18")],
      dateVals: "",
      pickTime: "",
      simpleSelectModel: [],
      multiSelectModel: [],
      multiSelectCountriesModel: [],
      radioSelectedOption: "option1",
      radioSelectedDisableOption: "option1",
      checkbox: {
        unselected: false,
        selected: true,
        readonly: true,
        disabled: true,
        error: false,
        errorMessages: true,
      },
      errorMessages: ["error message 1", "error message 2"],
      datepicker: {
        simple: "2018-05-09",
        time: "2018-05-08 14:10",
        range: "2018-05-08 to 2018-05-23",
        disabled: "2018-05-09",
        multiple: "2018-04-25, 2018-04-27",
        customFirstDay: "2018-05-09",
        customDate: "2018-05-09",
      },
      totalAmount: {
        success: "",
        refused: "",
      },
    };
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
  },
  created() {
    this.$nextTick(() => {
      this.$validator.validateAll();
    });
  },

  mounted() {
    this.selecting();
    this.nowTimes();
    //   this.draw();
    // this.sdraw();
    let nowDate = new Date();
    let year = nowDate.getFullYear();
    // let month = nowDate.getMonth() + 1;
    // let day = nowDate.getDate();
    let month =
      nowDate.getMonth() + 1 < 10
        ? "0" + (nowDate.getMonth() + 1).toString()
        : (nowDate.getMonth() + 1).toString(); // '04'
    // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
    let day =
      nowDate.getDate() < 10
        ? "0" + nowDate.getDate().toString()
        : nowDate.getDate().toString();
    let endTime = `${year}-${month}-${day}`;
    this.nowTime = endTime; // 当前的时间点
    let befDate = new Date(nowDate.getTime() - 60 * 24 * 3600 * 1000);
    let byear = befDate.getFullYear();
    let bmonth =
      befDate.getMonth() + 1 < 10
        ? "0" + (befDate.getMonth() + 1).toString()
        : (befDate.getMonth() + 1).toString(); // '04'
    // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
    let bday =
      befDate.getDate() < 10
        ? "0" + befDate.getDate().toString()
        : befDate.getDate().toString();
    let startTime = `${byear}-${bmonth}-${bday}`;
    this.weekBeforeTime = startTime; // 向前推迟一周的时间点
    let d = {};
    this.dateVals = [startTime, endTime];
    this.boarding(startTime, endTime, d);
  },

  methods: {
    clear(field) {
      this[field] = "";
    },
    // 为移动端设置日历面板展示
    setCalendarPanel() {
      if (this.isMobile === "mobile") {
        let datePicker = document.querySelector(".el-picker-panel");
        if (datePicker) {
          datePicker.style.display = "block";
          datePicker.style.width = "300px";
          datePicker.style.left = "10px";
          datePicker.style.top =
            document.querySelector(".el-date-editor").offsetTop + "px";
          document.querySelector(
            ".el-date-range-picker .el-picker-panel__body"
          ).style.minWidth = "300px";
          document.querySelector(
            ".el-date-range-picker__content.is-left"
          ).style.width = "100%";
          document.querySelector(
            ".el-date-range-picker__content.is-right"
          ).style.width = "100%";
        }
      }
    },
    // 获取当前时间函数
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let day =
        week[new Date(timeStamp).getDay()] < 10
          ? "0" + week[new Date(timeStamp).getDay()]
          : week[new Date(timeStamp).getDay()];

      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        " " +
        day +
        " " +
        hh +
        ":" +
        mm +
        ":" +
        ss;
      // console.log(this.nowTime);
    },
    // 定时器函数
    nowTimes() {
      this.timeFormate(new Date());
      // setInterval(this.nowTimes,1);
    },
    // 设置默认日期
    defaultDate() {
      // 获取新的时间(2019.4.12）
      let date = new Date();
      // 获取当前时间的年份转为字符串
      let year = date.getFullYear().toString(); // '2019'
      // 获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString(); // '04'
      // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let da =
        date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString(); // '12'
      // 字符串拼接，开始时间，结束时间
      let end = year + "-" + month + "-" + da; // 当天'2019-04-12'
      let beg = year + "-" + month + "-01"; // 当月第一天'2019-04-01'
      this.dateVals = [beg, end]; // 将值设置给插件绑定的数据
    },

    dateChangebirthday1(val) {
      this.pickTime = val;
    },

    selecting() {
      let token = localStorage.getItem("Authorization");
      let uid = localStorage.getItem("uid");
      let url =
        "api/dashboard/basic/getDropdown?app_id=" +
        this.value_app +
        "&access_token=" +
        token;
      request({
        method: "post",
        url,
        "": {},
      }).then((res) => {
        if (!!res) return
        // res是返回结果
        this.appList = res.data.apps;
        this.currencyList = res.data.order_currency;
        this.methodList = res.data.method;
      });
    },

    setSearch() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1).toString()
          : (nowDate.getMonth() + 1).toString(); // '04'
      // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let day =
        nowDate.getDate() < 10
          ? "0" + nowDate.getDate().toString()
          : nowDate.getDate().toString();
      let endTime = `${year}-${month}-${day}`;
      this.nowTime = endTime; // 当前的时间点
      let befDate = new Date(nowDate.getTime() - 60 * 24 * 3600 * 1000);
      let byear = befDate.getFullYear();
      let bmonth =
        befDate.getMonth() + 1 < 10
          ? "0" + (befDate.getMonth() + 1).toString()
          : (befDate.getMonth() + 1).toString(); // '04'
      // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let bday =
        befDate.getDate() < 10
          ? "0" + befDate.getDate().toString()
          : befDate.getDate().toString();
      let startTime = `${byear}-${bmonth}-${bday}`;
      // this.weekBeforeTime = startTime; // 向前推迟一周的时间点
      let data = {
        app_id: this.value_app,
        currency: this.value_cur,
        method: this.value_method,
      };

      if (this.pickTime[0] == undefined || this.pickTime[1] == undefined) {
        this.boarding(startTime, endTime, data);
      } else {
        this.boarding(this.pickTime[0], this.pickTime[1], data);
      }
    },
    // 计算总金额
    getAmountByKind(data) {
      let successAmount = new BigNumber(0);
      let refusedAmount = new BigNumber(0);
      let amountDatas = Object.values(data);
      for (let i = 0; i < amountDatas.length; i++) {
        if (amountDatas[i].SUCCESS) {
          if (i === 0) {
            successAmount = successAmount.plus(amountDatas[i].SUCCESS);
          } else {
            successAmount = successAmount.plus(amountDatas[i].SUCCESS);
          }
        }
        if (amountDatas[i].REFUSED) {
          if (i === 0) {
            refusedAmount = refusedAmount.plus(amountDatas[i].REFUSED);
          } else {
            refusedAmount = refusedAmount.plus(amountDatas[i].REFUSED);
          }
        }
      }
      this.$set(this.totalAmount, "success", successAmount.toNumber());
      this.$set(this.totalAmount, "refused", refusedAmount.toNumber());
    },
    boarding(startDate, endDate, queryParams) {
      let token = localStorage.getItem("Authorization");
      let qChart = this.$echarts.init(this.$refs.qChart);
      let sChart = this.$echarts.init(this.$refs.sChart);
      let url =
        "api/dashboard/report/getReportInfo?start=" +
        startDate +
        "&end=" +
        endDate +
        "&access_token=" +
        token +
        "";
      request({
        method: "post",
        url: url,
        data: queryParams,
        headers: {
          "Content-Type": "	application/json",
        },
      }).then((res) => {
        // res是返回结果
        // Summarys
        this.revenue = ["N/A"];
        this.volume = ["N/A"];
        this.avg = ["N/A"];
        if (res.data.currency_detail !== undefined) {
          let currencyDetail = res.data.currency_detail;
          let index = 0;
          for (var cur in currencyDetail) {
            this.revenue[index] =
              cur + "  " + toMoney(currencyDetail[cur].amount_sum, 2);
            this.volume[index] = toMoney(currencyDetail[cur].count_sum, 0);
            this.avg[index] =
              cur + "  " + toMoney(currencyDetail[cur].average, 2);
            index++;
          }
        }

        // Methods Distribution Pie Chart
        let mdChartsData = res.data.method_distribution;
        let mdIndex = 0;
        let mdLegend = [];
        let mdSeries = [];
        for (var md in mdChartsData) {
          mdLegend[mdIndex] = md;
          let item = {};
          item["name"] = md;
          item["value"] = mdChartsData[md];
          mdSeries[mdIndex] = item;
          mdIndex++;
        }

        qChart.setOption({
          // color: ['#3398DB'],
          title: {
            text: "Methods Distribution",
            // subtext: 'SUB TEXT',
            left: "top",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
            // formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            type: "scroll",
            orient: "horizontal",
            bottom: "10",
            data: mdLegend,
          },
          // 外层数组可实现大饼套小饼
          series: [
            {
              name: "",
              type: "pie",
              radius: "60%",
              center: ["50%", "50%"],
              data: mdSeries,
            },
          ],
        });

        // Currency Donuts Chart
        let cdChartsData = res.data.top_countries;
        let cdIndex = 0;
        let cdLegend = [];
        let cdSeries = [];
        for (var cd in cdChartsData) {
          cdLegend[cdIndex] = cd;
          let item = {};
          item["name"] = cd;
          item["value"] = cdChartsData[cd];
          cdSeries[cdIndex] = item;
          cdIndex++;
        }

        sChart.setOption({
          // color: ['#3398DB'],
          title: {
            text: "Currency",
            left: "top",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
          },
          legend: {
            type: "scroll",
            bottom: "10",
            data: cdLegend,
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "60%"],
              avoidLabelOverlap: true,
              label: {
                normal: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "40",
                    fontWeight: "bold",
                  },
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: cdSeries,
            },
          ],
        });

        // List data
        this.listData = res.data.total_list;
        // 合计金额
        this.getAmountByKind(this.listData);
      });
    }, // end boarding
  }, // end method
};

// 将数字转换成金额显示
function toMoney(num, decimals) {
  if (num) {
    if (isNaN(num)) {
      return;
    }
    num = typeof num === "string" ? parseFloat(num) : num; // 判断是否是字符串如果是字符串转成数字
    num = num.toFixed(decimals); // 保留两位
    num = parseFloat(num); // 转成数字
    num = num.toLocaleString("en-US"); // 转成金额显示模式
    if (decimals == 0) {
      return num;
    }
    // 判断是否有小数
    if (num.indexOf(".") == -1) {
      num = num + ".00";
    } else {
      num = num.split(".")[1].length < 2 ? num + "0" : num;
    }
    return num; // 返回的是字符串23,245.12保留2位小数
  } else {
    return (num = 0);
  }
}

/*
 * 参数说明：
 * number：要格式化的数字
 * decimals：保留几位小数
 * dec_point：小数点符号
 * thousands_sep：千分位符号
 * */
function number_format(number, decimals, dec_point, thousands_sep) {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}
</script>
<style>
@media only screen and (max-width: 750px) {
  .el-date-range-picker {
    width: 300px !important;
    position: absolute;
    left: 10px !important;
    top: 100px !important;
  }
  .el-date-range-picker .el-picker-panel__body {
    min-width: 300px !important;
  }
  .el-date-range-picker__content.is-left {
    width: 100% !important;
  }
  .el-date-range-picker__content.is-right {
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
.hello {
  display: block;
  font-size: 18px;
  color: #5ce490;
}
.color {
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: $VUE_APP_COLOR3;
}
@media (min-width: 1200px) {
  .flex.xl3 {
    -ms-flex-preferred-size: 33.3%;
    flex-basis: 33.3%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 33.3%;
  }
}
.el-select {
  display: block;
  position: relative;
}
.select-title {
  color: $VUE_APP_COLOR3;
}
.el-date-editor .el-range-separator {
  width: 14% !important;
}
.el-range-editor.el-input__inner {
  width: 100%;
}
/deep/ .vuestic-widget .vuestic-widget-header {
  font-size: 1.2rem;
}
/deep/ .btn-micro {
  letter-spacing: 1px;
  .btn-with-icon-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    max-width: 160px;
    .fa-refresh {
      width: 20px;
    }
    b {
      font-weight: 400;
    }
  }
}

@media only screen and (max-width: 750px) {
  /deep/ #datagridSettlement.vuestic-widget {
    .vuestic-widget-header {
      padding-left: 10px;
      font-size: 16px;
    }
    .vuestic-widget-body {
      padding: 0.2rem;
      .table-responsive {
        overflow-x: auto;
      }
      .first-td-padding td:first-child {
        padding-left: 0.5rem !important;
      }
    }
  }
}
</style>
